import {Component, ViewChild} from '@angular/core';

import { AlertController, NavController } from 'ionic-angular';
import { ModalController, ViewController,NavParams } from 'ionic-angular';



import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import { UiData } from "../../../providers/ui-data";
import { JobDataService } from '../../../providers/job-data';

import { SearchPipe } from '../../../pipes/search/search';

import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import { Observable } from 'rxjs/Observable';

@Component({
    selector: 'page-jobselect',
    templateUrl: 'job-select.html'
})
export class JobSelectForm {

    term: any;
    jobList: any;

    constructor(
        public viewCtrl: ViewController,
        public params: NavParams,
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
    ) {
        this.jobList = this.uiData.jobList();
    }
    saveItem() {

    }
    @ViewChild('search') search ;
    ngAfterViewInit() {

            this.search.setFocus();
    }
    chooseJob(job)
    {
        let data = { success:true, name:job.name , code:job.code };
        this.viewCtrl.dismiss(data);
    }
    dismiss() {
        let data = { success:false };
        this.viewCtrl.dismiss(data);
    }

}


// WEBPACK FOOTER //
// ./src/pages/utils/job-select/job-select.ts